import type { PlaylistItem } from '@apm/contracts';
import type { Translator } from '@apm/i18n';
import type { MessageKey } from './i18n/ko.js';

/**
 * 회차 라벨 (v16). `S1 · 3회` 또는 `3회`, 회차가 없으면 제목만.
 *
 * **사전을 거친다** (절대 규칙 24). 「회」·「S」를 컴포넌트에 직접 쓰면 영어 화면에 한글이
 * 남고, `verify-locale.mjs` 의 한글 훑기가 그것을 신고한다.
 *
 * **회차 번호는 등록된 값이라 번역 대상이 아니다** — 번역되는 것은 그것을 감싸는 틀이다.
 * 그래서 이 함수를 쓰는 자리에는 `data-i18n="data"` 를 붙이지 않는다: 틀이 번역되므로
 * 영어 화면에 한글이 남지 않는다. 제목·줄거리는 그 반대라 표시가 필요하다.
 */
export function episodeLabel(t: Translator<MessageKey>, item: PlaylistItem): string {
  const content = item.content;
  if (content === null || content.episodeNo === null) return item.title;
  if (content.seasonNo === null) {
    return t('episodes.labelNoSeason', { episode: content.episodeNo });
  }
  return t('episodes.label', { season: content.seasonNo, episode: content.episodeNo });
}
